import React from "react";
import PropTypes from "prop-types";

import ModalDialog from "components/ModalDialog";
import Button from "components/Button";

import "./StockLimitReachedAlert.css";

export default class StockLimitReachedAlert extends React.Component {

  static propTypes = {
    isOpen: PropTypes.bool,
    itemName: PropTypes.string.isRequired
  }

  static defaultProps = {
    isOpen: true
  }

  onOKClick = () => {
    this.props.onClose(true);
  }

  render() {
    const { isOpen, itemName} = this.props;
    return (
      <ModalDialog isOpen={isOpen}>
        <div>
          <div className="stock-limit-reached__title">Alert</div>
          <div className="stock-limit-reached__message">Stock Limit reached for item {itemName}. Please check back later.</div>
          <div className="stock-limit-reached__button-container">
            <Button className="stock-limit-reached__ok-button" onClick={this.onOKClick}>OK</Button>
          </div>
        </div>
      </ModalDialog>
    );
  }

}



// WEBPACK FOOTER //
// ./src/components/school_money/shop/StockLimitReachedAlert.js